









































































































import Vue from 'vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import MStoreFormGroup from '@/components/shared/MStoreFormGroup.vue';
import { FormFieldValidation } from '@/mixins';
import { RecurrenceModel, RecurrenceIntervalType } from '@/types';
import { WeekConstants } from '@/types/constants';
import moment from 'moment';

export default Vue.extend({
  name: 'MStoreRecurrence',
  mixins: [FormFieldValidation],
  props: {
    value: {
      type: Object as () => RecurrenceModel,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    intervalType: {
      get(this: any) {
        return this.value.intervalType;
      },
      set(this: any, value) {
        this.$emit('input', { ...this.value, intervalType: value });
      }
    },
    interval: {
      get(this: any) {
        return this.value.interval;
      },
      set(this: any, value) {
        this.$emit('input', { ...this.value, interval: Number(value) });
      }
    },
    withinTimeWindow: {
      get(this: any) {
        return this.value.withinTimeWindow;
      },
      set(this: any, value) {
        this.$emit('input', { ...this.value, withinTimeWindow: value });
      }
    },
    timeWindowFromHour: {
      get(this: any) {
        return this.value.timeWindowFromHour;
      },
      set(this: any, value) {
        this.$emit('input', { ...this.value, timeWindowFromHour: value });
      }
    },
    timeWindowToHour: {
      get(this: any) {
        return this.value.timeWindowToHour;
      },
      set(this: any, value) {
        this.$emit('input', { ...this.value, timeWindowToHour: value });
      }
    },
    onSpecificDays: {
      get(this: any) {
        return this.value.onSpecificDays;
      },
      set(this: any, value) {
        this.$emit('input', { ...this.value, onSpecificDays: value });
      }
    },
    specificDays: {
      get(this: any) {
        return this.value.specificDays;
      },
      set(this: any, value) {
        this.$emit('input', { ...this.value, specificDays: value });
      }
    },
    timeZone: {
      get() {
        return this.value.timeZoneCode;
      },
      set(value: string) {
        this.$emit('input', { ...this.value, timeZoneCode: value });
      }
    },
    intervalValidation(this: any) {
      return { minValue: 1, maxValue: this.intervalType === 0 ? 59 : 23 };
    },
    checkboxClass(this: any) {
      return { 'noselect opacity-65': !this.onSpecificDays };
    }
  },
  methods: {
    generateHourOptions(minutes: number) {
      const hourOptions = Array.from({ length: 24 })
        .fill({})
        .map((value, index) => ({
          value: index,
          text: new Date(2018, 0o5, 0o5, index, minutes, 0, 0)
            .toLocaleString('default', { hour: 'numeric', minute: 'numeric', hour12: true })
            .padStart(8, '0')
        }));
      return hourOptions;
    }
  },
  mounted(this: any) {
    this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  },
  created(this: any) {
    this.WEEK_DAYS = WeekConstants.days;
    this.INTERVAL_TYPES = [
      { value: RecurrenceIntervalType.minute, text: 'Minutes' },
      { value: RecurrenceIntervalType.hour, text: 'Hours' }
    ];
    this.TIME_WINDOW_FROM_HOURS = this.generateHourOptions(0);
    this.TIME_WINDOW_TO_HOURS = this.generateHourOptions(59);
    this.TIMEZONE_UTC_OFFSET = `UTC${moment().format('Z')}`;
  },
  components: {
    MStoreFormInput,
    MStoreFormGroup
  }
});
